import { render, staticRenderFns } from "./user-select.vue?vue&type=template&id=8cd84ba4&"
import script from "./user-select.vue?vue&type=script&lang=js&"
export * from "./user-select.vue?vue&type=script&lang=js&"
import style0 from "./user-select.vue?vue&type=style&index=0&id=8cd84ba4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports